export default "__VITE_ASSET__8dc95cca__"